
export const REACT_APP_CANDIDATE_FREELANCER = 'https://api.ellow.io/candidate-freelancer/api/v1/mwp';
export const REACT_APP_JOB = 'https://api.ellow.io/job/api/v1/mwp';
export const REACT_APP_CONTRACT = 'https://api.ellow.io/contract/api/v1/mwp';
export const REACT_APP_CANDIDATE = 'https://api.ellow.io/candidate/api/v1/mwp';
export const REACT_APP_TIMESHEET = 'https://api.ellow.io/timesheet/api/v1/mwp';
export const REACT_APP_TIMESHEET_PAYMENT = 'https://api.ellow.io/timesheetpayment/api/v1/mwp';
export const REACT_APP_PROFILE = 'https://api.ellow.io/profile/api/v1/mwp';
export const REACT_APP_VERIFY = 'https://api.ellow.io/verification/api';
export const REACT_APP_CONTRACTSIGN = '`https://api.ellow.io/contractsign/api/v1/mwp';
